import { render, staticRenderFns } from "./macro.vue?vue&type=template&id=b4f2482c&scoped=true"
import script from "./macro.vue?vue&type=script&lang=js"
export * from "./macro.vue?vue&type=script&lang=js"
import style0 from "./macro.vue?vue&type=style&index=0&id=b4f2482c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f2482c",
  null
  
)

export default component.exports